import React, { useMemo } from 'react';
import SignupContentWrapper from '../../components/SignupContentWrapper';
import { useTranslation } from 'react-i18next';
import { useRouteConfig } from '../../utils/useRouteConfig';
import { PATH } from '../../../../routes';
import OrganizationManualEntryFormV1 from './v1/OrganizationManualEntryForm';
import OrganizationManualEntryFormV2 from './v2/OrganizationManualEntryForm';
import { useSelector } from 'react-redux';
import { AppState } from 'store';
import { Features } from 'store/featureFlags/types';
import { useFullStoryIdentity } from 'pages/signup/utils/useFullStoryIdentity';

const STEP_INFO = 1;

const AddOrganization: React.FC = () => {
    const { fingerprint, fullStoryEnabled, newSearchUIEnabled, enabledFeaturesLoading } = useSelector(
        (state: AppState) => ({
            fingerprint: state.Signup.fingerprint,
            fullStoryEnabled: state.FeatureFlagging.features[Features.FULLSTORY],
            newSearchUIEnabled:
                state.FeatureFlagging.features[Features.SEARCH_UI_V2],
            enabledFeaturesLoading: state.FeatureFlagging.isLoading,
        }),
    );
    const { t } = useTranslation();
    useFullStoryIdentity({
        enabled: fullStoryEnabled && newSearchUIEnabled,
        fingerprint,
    });
    const { previous } = useRouteConfig(PATH.SIGNUP.STEPS.ADD_ORGANIZATION);
    const { heading, headingV2, subHeading } = useMemo(
        () => ({
            heading: t('signup.organizationName.headingNewAdd'),
            headingV2: t('signup.organizationName.headingNewAddV2'),
            subHeading: t('signup.organizationName.subHeading'),
        }),
        [t],
    );

    if (enabledFeaturesLoading) {
        return null;
    }

    return (
        <SignupContentWrapper
            showCloseButton={true}
            heading={newSearchUIEnabled ? headingV2 : heading}
            subHeading={subHeading}
            stepInfo={STEP_INFO}
            backUrl={previous}
        >
            {newSearchUIEnabled ? (
                <OrganizationManualEntryFormV2 />
            ) : (
                <OrganizationManualEntryFormV1 />
            )}
        </SignupContentWrapper>
    );
};

export default AddOrganization;
